import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label", "value"]
const _hoisted_2 = { value: "" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "uv-filters-expand-box-inner" }
const _hoisted_5 = ["name", "id", "value", "checked"]
const _hoisted_6 = ["for"]

import { computed, ref, watch } from "vue";
	import { IFilterMultiSelectOption, TOptionValue } from '@/types';
	import { ArrowUp, ArrowDown } from '@/svg';

	
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    name: null,
    options: null,
    closedDefault: { type: Boolean }
  },
  emits: ['change'],
  setup(__props: any, { emit }) {

const props = __props as {
		title: string,
		name: string,
		options: Array<IFilterMultiSelectOption<TOptionValue>>, 
		closedDefault?: boolean
	}

	

	

	const defaultOpenState = !props.closedDefault;

	const isOpen = ref(defaultOpenState);
	const inputEls = ref<any>([]);

	const originalType = computed((): string => typeof (props.options.length ? props.options[0].value : ''));
	const filtersClass = computed((): string => `uv-filters-${props.name}`);
	const selectedOptions = computed((): Array<IFilterMultiSelectOption<TOptionValue>> => props.options.filter((o: IFilterMultiSelectOption<TOptionValue>) => o.selected));
	const firstSelectedOptionValue = computed(():TOptionValue  => selectedOptions.value.length ? selectedOptions.value[0].value : '');
	const filterBoxClass = computed(() => `uv-filters-expand-box ${isOpen.value ? 'open' : 'closed'}`);
	const showClear = computed(() => props.options.filter((o:IFilterMultiSelectOption<TOptionValue>) => o.selected).length);

	const handleSelectChange = ($event: Event): void => {
		let val: TOptionValue = ($event.target as HTMLInputElement).value;
		switch (originalType.value){
			case 'number':
				val = parseInt(val);
			break;
			case 'boolean':
				val = val.toLowerCase() == 'true';
			break;
		}
		emit('change', [val]);
	};
	const handleToggleOpen = ($event: Event) => {
		$event.preventDefault();
		isOpen.value = !isOpen.value;
	};
	const handleClearClick = ($event: Event) => {
		$event.preventDefault();
		emit('change', []);
	};
	const handleCheckboxChange = ($event: Event) => {
		let val: TOptionValue = ($event.target as HTMLInputElement).value;
		switch (originalType.value){
			case 'number':
				val = parseInt(val);
			break;
			case 'boolean':
				val = val.toLowerCase() == 'true';
			break;
		}
		let selectedValues: Array<TOptionValue> = props.options
			.filter((o: IFilterMultiSelectOption<TOptionValue>) => o.selected)
			.map((o: IFilterMultiSelectOption<TOptionValue>) => o.value)
		;
		if (selectedValues.includes(val)){
			selectedValues = selectedValues.filter((o: TOptionValue) => o != val);
		}
		else {
			selectedValues.push(val);
		}
		emit('change', selectedValues);
	}

	const updateCheckbox = (value: TOptionValue, selected: boolean) => {
		for (let i = 0; i != inputEls.value.length; ++i){
			const el = (inputEls.value[i] as HTMLInputElement);
			if (!el) return;
			if (value == el.value){
				el.checked = selected;
			}
		}
	}

	const propsOptions = computed((): Array<IFilterMultiSelectOption<TOptionValue>> => props.options);
	watch(propsOptions, (currVal, oldVal) => {
		for (const c of currVal){
			const oArr = oldVal.filter(o => o.value == c.value);
			if (oArr.length && oArr[0].selected != c.selected){
				updateCheckbox(oArr[0].value, c.selected);
			}
		}
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(filtersClass))
  }, [
    _createElementVNode("select", {
      class: "uv-select",
      "aria-label": `Filter by ${__props.title}`,
      value: _unref(firstSelectedOptionValue),
      onChange: handleSelectChange
    }, [
      _createElementVNode("option", _hoisted_2, _toDisplayString(__props.title) + " - All", 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (opt, i) => {
        return _withDirectives((_openBlock(), _createElementBlock("option", {
          key: i,
          value: opt.value
        }, _toDisplayString(opt.text) + " (" + _toDisplayString(opt.count) + ") ", 9, _hoisted_3)), [
          [_vShow, opt.count]
        ])
      }), 128))
    ], 40, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(_unref(filterBoxClass))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, [
          _createElementVNode("button", {
            type: "button",
            class: "uv-filter-toggle",
            onClick: handleToggleOpen
          }, [
            _createTextVNode(_toDisplayString(__props.title) + " ", 1),
            (isOpen.value)
              ? (_openBlock(), _createBlock(_unref(ArrowUp), { key: 0 }))
              : (_openBlock(), _createBlock(_unref(ArrowDown), { key: 1 }))
          ]),
          (_unref(showClear))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn-clear button-link",
                onClick: handleClearClick
              }, "Clear"))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (opt, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, [
              _createElementVNode("input", {
                type: "checkbox",
                autoComplete: "off",
                ref_for: true,
                ref: (el) => { inputEls.value[i] = el },
                name: `uv-filter-option-${__props.name}`,
                id: `uv-filter-option-${__props.name}-${i}`,
                value: opt.value,
                checked: opt.selected,
                onChange: handleCheckboxChange
              }, null, 40, _hoisted_5),
              _createElementVNode("label", {
                for: `uv-filter-option-${__props.name}-${i}`
              }, [
                _createTextVNode(_toDisplayString(opt.text) + " ", 1),
                _createElementVNode("span", null, "(" + _toDisplayString(opt.count) + ")", 1)
              ], 8, _hoisted_6)
            ]))
          }), 128))
        ], 512), [
          [_vShow, __props.options.length]
        ])
      ])
    ], 2)
  ], 2))
}
}

})